<div class='component-box'>
  <!--  顶部检索框-->
  <div class='search-box'>
    <nz-input-group class='selfRadius' [nzSuffix]='searchIcon'>
      <input nz-input class='selfRadius' placeholder='搜索' [(ngModel)]='searchKey' />
      <ng-template #searchIcon>
        <i nz-icon nzIconfont='icon_search' class='text-gray1'></i>
      </ng-template>
    </nz-input-group>
  </div>
  <!-- 顶部检索框 End-->
  <!--  组织类型单选按钮-->
  <div class='organ-type-box mt-md'>
    <nz-radio-group [(ngModel)]='organType' (ngModelChange)='switchType($event)'>
      <ng-container *ngFor='let organ  of data'>
        <label nz-radio-button [nzValue]="organ['organ_type']">{{organ['organ_name']}}</label>
      </ng-container>
    </nz-radio-group>
  </div>
  <!--  组织类型单选按钮 End-->
  <!--  详细数据展示模块-->
  <div class='tree-data-box'>
    <!--  岗位模板树形数据信息-->
    <div class='duties-tpl-tree-box  structure-tree  mt-sm' *ngIf='useDutiesTpl'>
      <nz-tree
        [nzData]='showTemplate'
        [nzTreeTemplate]='treeTpl'
        [nzCheckStrictly]='true'
        (nzClick)='checkTpl($event)'
        [nzSelectedKeys]='checkTplId'
        [nzSearchValue]='searchKey'
        nzHideUnMatched
        style='background: var(--gray-bg)'
      >
        <ng-template #treeTpl let-node>
          <div class='flexRow text-nowrap text-truncate '>
            <i nz-icon nzIconfont='icon_zu' *ngIf='node.level == 0' class='structure-icon mr-sm'></i>
            <i nz-icon nzIconfont='icon_duties'
               *ngIf='node.level > 0'
               class='structure-icon mr-sm'></i>
            <div class='mr-sm'>{{ node.title }}</div>
          </div>
        </ng-template>
      </nz-tree>
      <div style='padding:0 10px; '>
        <nz-divider></nz-divider>
      </div>
    </div>
    <!--  岗位模板树形数据信息 Eed-->
    <!--  自定义岗位数据信息-->
    <div class='duties-tpl-tree-box  structure-tree  mt-sm'>
      <nz-tree
        [nzData]='showDuties'
        [nzTreeTemplate]='structureTree'
        [nzSearchValue]='searchKey'
        nzHideUnMatched
        [nzCheckStrictly]='true'
        [nzExpandAll]='true'
        [nzExpandedKeys]='expandedKeys'
        (nzClick)='checkDuties($event)'
        [nzSelectedKeys]='checkDutiesId'

        style='background: var(--gray-bg)'
      >
        <ng-template #structureTree let-node>
          <div class='flexRow text-nowrap text-truncate '>
            <i nz-icon nzIconfont='icon_jiagou' *ngIf='node.level == 0' class='structure-icon mr-sm'></i>
            <i nz-icon nzIconfont='icon_pianqu'
               *ngIf="node.origin['organ_type']==1 && node.origin['organ_type_extra'] ==2"
               class='structure-icon mr-sm'></i>
            <i nz-icon nzIconfont='icon_arrive'
               *ngIf="node.origin['organ_type']==1 && node.origin['organ_type_extra'] ==3"
               class='structure-icon mr-sm'></i>
            <i nz-icon nzIconfont='icon_zu'
               *ngIf="(node.origin['organ_type_extra'] ==0 ||node.origin['organ_type_extra'] ==4)&&node.origin['organ_type']!=5 && node.level >0"
               class='structure-icon mr-sm'></i>
            <i nz-icon nzIconfont='icon_duties'
               *ngIf="node.origin['organ_type']==5"
               class='structure-icon mr-sm'></i>
            <div class='mr-sm'>{{ node.title }}</div>
          </div>
        </ng-template>
      </nz-tree>
    </div>
    <!--  自定义岗位数据信息-->
  </div>
  <!--  详细数据展示模块 End-->
</div>
